import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { MessageCard } from "../../../designSystem/MessageCard";
import { mobile } from "../../../designSystem/BreakPoints";

type ActivityInvitationStatusPanelProps = {
    activity: { start: Date, participantCount:number };
    status: 'not-sent' | 'up-to-date' | 'has-changes';
    onClick: () => void;
}

export function ActivityInvitationStatusPanel(props: ActivityInvitationStatusPanelProps) 
{
    const showInvitationWarning = 
        (props.activity.start > new Date()) && 
        (props.status === 'not-sent' || props.status === 'has-changes') &&
        (props.activity.participantCount > 0);

    return (
        <>
            {showInvitationWarning &&
                <MessageCard variant="warning" textAlign="left" style={{ marginTop:16}}>
                    <Flex justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={24}>
                        <div style={{ flex: `1 1 ${mobile}px` }}>
                            {props.status === 'has-changes' && 
                                <>Mødet er blevet opdateret. Husk at opdatere nye, eksisterende og fjernede deltagere om ændringerne. 
                                Klik på knappen for automatisk at sende en opdatering til nye- og evt. tidligere deltagere.</> 
                            }

                            {props.status === 'not-sent' &&
                                <>Mødet er nyoprettet. Husk at sende at informere de inviterede deltagere.
                                Klik på knappen for automatisk at sende en invitation.</> 
                            }
                            
                        </div>
                        
                        {/* Pushes right when wrapped */}
                        <div style={{marginLeft:'auto'}}>
                        <Button text={props.status === 'has-changes' ? "Send opdatering" : "Send invitation"} variant="outlined" onClick={props.onClick} />
                        </div>
                    </Flex>
                </MessageCard>
                        
            }
        </>
    );
}